import { MarkerIcon } from '@rsos/assets/icons';
import { Box, Text } from '@rsos/components/capstone/base';
import usePrimaryCallLocations from '@rsos/hooks/usePrimaryCallLocations';
import useSecondaryCallLocations from '@rsos/hooks/useSecondaryCallLocations';

export const LocationInformation = () => {
  const primaryLocations = usePrimaryCallLocations();
  const secondaryLocations = useSecondaryCallLocations();

  const location = primaryLocations[0] || secondaryLocations[0];
  const address = location?.rgAddress;

  if (!address) {
    return null;
  }

  return (
    <Box horizontal align="center" marginTop={2}>
      <MarkerIcon color="primaryText" width={12} height={12} />
      <Text
        color="primaryText"
        marginLeft={2}
        size="normal"
        lineHeight="normal"
      >
        {address}
      </Text>
    </Box>
  );
};
